export default "__VITE_ASSET__3ada04c8__"